import { useState, useMemo, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import classes from "./style.module.css";
import { Row, Col, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";

export const FilterForm = (props) => {
  const { setFilterData, setPage, template } = props;
  const [searchParams, setSearchParams] = useSearchParams();

  const initialValues = useMemo(() => {
    return {
      name: searchParams.get('name') || '',
      status: searchParams.get('status') || '',
      scheduledDateTime: searchParams.get('scheduledDateTime')
        ? new Date(searchParams.get('scheduledDateTime'))
        : null,
      channel: searchParams.get('channel') || '',
    };
  }, [searchParams]);

  const { channels } = useSelector((state) => state.channelsSlice);

  useEffect(() => {
    const params = Object.fromEntries([...searchParams.entries()]);
    const page = params.page ? parseInt(params.page, 10) : 1;

    const filterData = {};
    Object.entries(params).forEach(([key, value]) => {
      if (value && key !== 'page') {
        if (key === 'channel') {
          filterData[key] = { id: value };
        } else {
          filterData[key] = value;
        }
      }
    });

    setFilterData(filterData);
    setPage(page);
  }, [searchParams, setFilterData, setPage]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      const params = new URLSearchParams();

      Object.entries(values).forEach(([key, value]) => {
        if (value) {
          if (key === 'scheduledDateTime') {
            params.set(key, value.toISOString().split('T')[0]);
          } else {
            params.set(key, value);
          }
        }
      });

      params.set('page', '1');
      setSearchParams(params);
    },
  });

  const handleReset = () => {
    setSearchParams({});
  };

  const getChannelOptions = () => {
    try {
      return channels.data.map((channel) => (
        <option key={channel.name} value={channel.id} label={channel.name}>
          {channel.name}
        </option>
      ));
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Row className="mb-3">
        <Col md={5}>
          {
            hasPermission(PERMISSIONS.CAMPAIGN.CREATE) && <div className="form-floating">
              <Link className="btn btn-primary" to="/campaigns/new">Add Campaign</Link>
            </div>
          }
        </Col>
        <Col md={7}>
          <Row>
            <Col>
              <label htmlFor="name">Campaign Name or ID</label>
              <input
                name="name"
                type="text"
                className="form-control"
                placeholder="Search by ID or Name"
                onChange={formik.handleChange}
                value={formik.values.name}
              />
            </Col>
            <Col>
              <label htmlFor="scheduledDateTime">Start Date</label>
              <DatePicker
                selected={formik.values.scheduledDateTime}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                name="scheduledDateTime"
                onChange={(date) =>
                  formik.setFieldValue("scheduledDateTime", date)
                }
              />
            </Col>
            <Col>
              <label htmlFor="email">Channel</label>
              <select
                className="form-select"
                name="channel"
                value={formik.values.channel}
                onChange={formik.handleChange}
                style={{ display: "block" }}
              >
                <option value="" label="Select a Channel">
                  Select a Channel
                </option>
                {getChannelOptions()}
              </select>
            </Col>
            <Col>
              <label htmlFor="status">Status</label>
              <select
                className="form-select"
                name="status"
                value={formik.values.status}
                onChange={formik.handleChange}
                style={{ display: "block" }}
              >
                <option value="" label="Select a Status">
                  Select Status
                </option>
                <option value="draft" label="Draft">
                  Draft
                </option>
                <option value="published" label="Published">
                  Published
                </option>
              </select>
            </Col>
          </Row>
          <Row>
            <Col>
              {formik.touched.name && formik.errors.name ? (
                <span className="error text-danger">{formik.errors.name}</span>
              ) : null}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Button as="input" type="submit" value="Filter" xs={4} md={1} />{" "}
              <Button onClick={handleReset} type="reset" variant="secondary">
                Reset
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </form>
  );
};